import { BankAccount, BankAccountType } from '@umss/shared/data-access';

export const MOCK_BANK_ACCOUNT: BankAccount = {
  id: '1',
  bankName: 'Chase',
  routingNumberMasked: '****0021',
  accountNumberMasked: '****7890',
  routingNumber: '021000021',
  accountNumber: '1234567890',
  isPrimary: true,
  isStripeLinked: true,
  accountType: BankAccountType.CHECKING,
  isVerified: true,
  verificationDate: '2025-08-06',
  stripeExternalAccountId: null,
  stripeBankAccountStatus: null
};

export const MOCK_BANK_ACCOUNTS: BankAccount[] = [
  {
    id: 'dfc97720-ea61-4582-b007-1bc428fb2e45',
    bankName: 'Wells Fargo',
    routingNumberMasked: '****0248',
    accountNumberMasked: '****1526',
    routingNumber: '121000248',
    accountNumber: '45781526',
    accountType: BankAccountType.CHECKING,
    isPrimary: true,
    isStripeLinked: true,
    isVerified: false,
    verificationDate: null,
    stripeExternalAccountId: null,
    stripeBankAccountStatus: null
  },
  {
    id: 'af62bcff-eb8b-47e2-b3bc-683c061a6fee',
    bankName: 'City Bank',
    routingNumberMasked: '****0089',
    accountNumberMasked: '****•411',
    routingNumber: '021000089',
    accountNumber: '•••••411',
    accountType: BankAccountType.CHECKING,
    isPrimary: false,
    isStripeLinked: false,
    isVerified: false,
    verificationDate: null,
    stripeExternalAccountId: null,
    stripeBankAccountStatus: null
  }
];
